import React from "react";
import styled from "styled-components";
import AnimatedButton from "./AnimatedButton";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Dialog = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #000;
`;

const Message = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  color: #333;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
`;

const ConfirmationDialog = ({ isOpen, onConfirm, onCancel, title, message }) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onCancel}>
      <Dialog onClick={(e) => e.stopPropagation()}>
        <Title>{title || "Are you sure?"}</Title>
        <Message>{message}</Message>
        <ButtonGroup>
          <AnimatedButton onClick={onCancel}>Go Back</AnimatedButton>
          <AnimatedButton onClick={onConfirm} primary>
            Yes, Continue
          </AnimatedButton>
        </ButtonGroup>
      </Dialog>
    </Overlay>
  );
};

export default ConfirmationDialog;

